// themes/majestic/index.js
//
// Central export point for the Majestic theme
// Bundles theme configuration, events, and story content

import majesticTheme from './majesticTheme.js';
import majesticEventsLibrary from './majesticEvents.js';
import majesticStoryLibrary from './majesticStory.js';

/**
 * Majestic Theme Bundle
 * Contains all configuration, content libraries, and narrative data
 * for the grand fantasy/epic adventure Majestic universe
 */
const majesticBundle = {
  // Theme configuration - visual, UI, and gameplay formatting
  theme: majesticTheme,
  
  // Event content library - backdrop, threat, morale, faction, discovery, campaign events
  events: majesticEventsLibrary,
  
  // Story content library - 4-chapter narrative arc and story threads
  story: majesticStoryLibrary
};

export default majesticBundle;

// Named exports for flexibility
export { majesticTheme, majesticEventsLibrary, majesticStoryLibrary };